import { FaDownload } from 'react-icons/fa';
import { useSiteConfig } from '../../context/SiteConfigContext';
import { useT } from '../../hooks/useT';
import { getIcon } from '../../utils/iconRegistry';
import styles from './ContactLinks.module.css';

function ContactLinks({ items = [], showDownload = true, downloadKey = '', subtitleKey = '', cvFile = '' }) {
  const config = useSiteConfig();
  const t = useT();

  return (
    <div className={styles.wrapper}>
      {subtitleKey && <p className={styles.subtitle}>{t(subtitleKey)}</p>}
      <div className={styles.links}>
        {items.map((item, i) => {
          const Icon = getIcon(item.icon);
          // Prefer direct url, fall back to socialLinks lookup
          const href = item.url || config.socialLinks?.[item.linkKey] || '#';
          return (
            <a key={item.labelKey || i} href={href} target="_blank" rel="noopener noreferrer" className={styles.contactLink}>
              {Icon && <Icon className={styles.icon} />}
              <span className={styles.label}>{t(item.labelKey)}</span>
            </a>
          );
        })}
      </div>
      {showDownload && downloadKey && (
        <a href={cvFile || config.socialLinks?.cvDownload || '#'} download className={styles.downloadBtn}>
          <FaDownload className={styles.downloadIcon} />
          {t(downloadKey)}
        </a>
      )}
    </div>
  );
}

export default ContactLinks;
